// extracted by mini-css-extract-plugin
export default {"mainWatchlistPage":"WatchList_mainWatchlistPage__Vl9cB"};